module.exports = __webpack_public_path__ + "img/Ordinarie.6ba38587.jpg";